import React from 'react'

import "./table.scss";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useEffect as uEffect, useState as uState } from "react";


export default function latestTransactions() {
    const [orderData, setOrderData] = uState([]);

    const fetchAllOrder = async () => {
      await fetch("http://localhost:8000/order/hourOrders", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      }).then(async (response) => await response.json())
        .then((data) => setOrderData(data));
    }
    const filteredProducts = orderData.filter(product => product.hasOwnProperty('ProductTitle'));

    filteredProducts.sort((a, b) => {
        if (a.ProductTitle < b.ProductTitle) {
            return 1;
        }
        if (a.ProductTitle > b.ProductTitle) {
            return -1;
        }
        return 0;
    });

    const latestTransactions = filteredProducts.slice(0, 4);

    uEffect(
      () => {
        fetchAllOrder()
      }, []
    )
let today =new Date().toDateString()
    // const formatDate = (date) => {
    //     return new Date(date).toLocaleDateString();
    // }

    return (
        <>
            <p>{ today}</p>
            <TableContainer component={Paper} className="table">
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell className="tableCell">Customer ID</TableCell>
                            <TableCell className="tableCell">Customer</TableCell>
                            <TableCell className="tableCell">Product Type</TableCell>
                            <TableCell className="tableCell">Product Name</TableCell>
                            <TableCell className="tableCell">Amount</TableCell>
                            {/* <TableCell className="tableCell">Payment Method</TableCell> */}
                            {/* <TableCell className="tableCell">Status</TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            <>
                                {latestTransactions.map((order,index) => (
                                    <TableRow key={index}>
                                        <TableCell className="tableCell">
                                            {order.UserId}
                                        </TableCell>
                                        <TableCell className="tableCell">
                                            {order.UserEmail}
                                        </TableCell>
                                        <TableCell className="tableCell">{order.ProductType}</TableCell>
                                                    <TableCell className="tableCell">
                                                        <div className="cellWrapper">
                                                            <img
                                                                src={`http://localhost:8000/public/images/${order.ProductImage}`}
                                                                alt=""
                                                                className="image"
                                                            />
                                                            {order.ProductTitle}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className="tableCell">
                                                        ₹{order.ProductAmount}
                                                    </TableCell>
                                    </TableRow>
                                ))}





                            </>
                        }
                    </TableBody>
                </Table>
            </TableContainer>


        </>
    )

}

